import React, { useState } from 'react'
import { useHomeStore } from '../../store/useHomeStore'
import TruncatedText from '../../Components/TruncatedText'
import { formatDate } from '../../lib/formateDate'
import { Link, useNavigate, useSearchParams } from 'react-router'
import { Box, Button, Modal, Typography } from '@mui/material'
import Loader from '../../Components/Loader'

const DisplayMarketArea = () => {
    let { marketArea, deleteMarketArea } = useHomeStore()
    const navigate = useNavigate()
    const [itemId, setItemId] = useState('');
    const [open, setOpen] = useState('');
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const [loading, setLoading] = useState(false)

    const handleDelete = (id) => {
        setItemId(id)
        setOpen(true)
    }

    const handleCancelDelete = () => {
        setOpen(false);
    };

    const handleConfirmDelete = async () => {
        try {
            setOpen(false)
            setLoading(true)
            const res = await deleteMarketArea(itemId)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }
    return (
        <div>
            <div className="bg-white rounded-md shadow-sm border border-neutral-200  mb-9 overflow-hidden">
                <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50 flex justify-between items-center">
                    <h3>Market Area</h3>
                    <div className="flex justify-end space-x-2">
                        <Link
                            to="/home/market/form"
                            className="px-4 py-2 bg-neutral-900 text-white rounded-md"
                        >
                            <i className="fa-solid fa-plus mr-2"></i>
                            Add Market area
                        </Link>
                    </div>
                </div>
                <table className="w-full">
                    <Loader loading={loading}>
                        <thead>
                            <tr className="bg-neutral-50 text-left text-xs text-neutral-500 uppercase tracking-wider">
                                <th className="px-6 py-3">Name</th>
                                <th className="px-6 py-3 w-[50%]">Description</th>
                                <th className="px-6 py-3 text-right">Actions</th>
                            </tr>
                        </thead>

                        <tbody className="divide-y divide-neutral-200">
                            {
                                (marketArea?.area || []).map((ele, i) => {
                                    return (
                                        <tr className="hover:bg-neutral-50" key={i}>
                                            <td className="px-6 py-4">
                                                <div className="flex items-center">
                                                    <div className="w-10 h-10 bg-neutral-600 flex items-center justify-center rounded-sm text-white text-xs mr-3">
                                                        <img src={ele?.image} alt="" className='rounded-sm' />
                                                    </div>
                                                    <span>{ele?.title}</span>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 text-sm text-neutral-600 w-[50%]">
                                                <TruncatedText text={ele?.description} limit={150} />
                                            </td>

                                            <td className="px-6 py-4 text-right text-sm">
                                                <Link
                                                    class="text-neutral-500 hover:text-neutral-700 mr-3"
                                                    to={`/home/market/form?id=${ele?._id}`}
                                                >
                                                    <i className="fa-solid fa-edit"></i>
                                                </Link>
                                                <button
                                                    className="text-neutral-500 hover:text-neutral-600"
                                                    onClick={() => handleDelete(ele?._id)}
                                                >
                                                    <i className="fa-solid fa-trash-alt"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })
                            }

                        </tbody>
                    </Loader>
                </table>

            </div>

            <Modal
                open={open}
                onClose={handleCancelDelete}
                aria-labelledby="confirm-delete-modal"
                aria-describedby="modal-to-confirm-deletion"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '5px',
                        boxShadow: 24,
                        width: { xs: "80%", md: "500px" },
                        textAlign: 'center',
                    }}
                >
                    <Typography variant="h6" gutterBottom>
                        Are you sure you want to delete this Market Area?
                    </Typography>
                    <Button variant="outlined" color="#274156" onClick={handleConfirmDelete}>
                        Yes
                    </Button>
                    <Button variant="outlined" color="#274156" onClick={handleCancelDelete} sx={{ marginLeft: '10px' }}>
                        No
                    </Button>
                </Box>
            </Modal>
        </div>
    )
}

export default DisplayMarketArea
